export default "__VITE_ASSET__CkPXwKMu__"